import { activeTimeFrame } from './activeTimeFrame';
export var CallStatus;
(function (CallStatus) {
    CallStatus["open"] = "Open";
    CallStatus["closedTemporarily"] = "Closed Temporarily";
    CallStatus["closed"] = "Closed";
})(CallStatus || (CallStatus = {}));
export const getCallStatus = (call) => {
    const firstStep = call.flow?.find((step) => step.order === 0);
    if (!call.published || !firstStep)
        return CallStatus.closed;
    if (activeTimeFrame(firstStep))
        return CallStatus.open;
    const reopens = (firstStep.timeframes || []).some((t) => new Date(t.start).getTime() > new Date().getTime());
    return reopens ? CallStatus.closedTemporarily : CallStatus.closed;
};
export const callStatusColor = (status) => status === CallStatus.open ? 'success' : status === CallStatus.closedTemporarily ? 'warning' : 'error';
